import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CartContent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="35028" id="cart-content" className="bg-background min-h-[60vh] py-24 relative overflow-hidden text-foreground">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="
          w-full
          
          
          [&_table.shop_table]:w-full 
          [&_table.shop_table]:border-collapse 
          [&_table.shop_table]:mb-12
          
          
          [&_th]:text-left 
          [&_th]:py-6 
          [&_th]:px-4 
          [&_th]:font-serif 
          [&_th]:text-xl 
          [&_th]:font-medium 
          [&_th]:text-muted-foreground 
          [&_th]:border-b 
          [&_th]:border-border/40
          [&_th]:tracking-wide
          
          
          [&_td]:py-8 
          [&_td]:px-4 
          [&_td]:border-b 
          [&_td]:border-border/20 
          [&_td]:align-middle
          
          
          [&_a.remove]:text-muted-foreground 
          [&_a.remove]:hover:text-destructive 
          [&_a.remove]:transition-colors 
          [&_a.remove]:text-3xl 
          [&_a.remove]:font-light
          [&_a.remove]:block
          [&_a.remove]:w-8
          [&_a.remove]:h-8
          [&_a.remove]:leading-8
          [&_a.remove]:text-center
          
          
          [&_img]:rounded-xl 
          [&_img]:border 
          [&_img]:border-border/10 
          [&_img]:w-24 
          [&_img]:h-24 
          [&_img]:object-cover
          [&_img]:bg-card
          
          
          [&_td.product-name_a]:text-foreground 
          [&_td.product-name_a]:font-medium 
          [&_td.product-name_a]:text-xl
          [&_td.product-name_a]:hover:text-primary 
          [&_td.product-name_a]:transition-colors
          [&_td.product-name_a]:font-serif
          
          
          [&_td.product-price]:text-muted-foreground
          [&_td.product-subtotal]:text-primary 
          [&_td.product-subtotal]:font-semibold
          
          
          [&_.quantity]:relative
          [&_.quantity_input]:bg-card/40 
          [&_.quantity_input]:border 
          [&_.quantity_input]:border-border/60 
          [&_.quantity_input]:text-foreground 
          [&_.quantity_input]:w-20 
          [&_.quantity_input]:text-center 
          [&_.quantity_input]:rounded-full 
          [&_.quantity_input]:py-2
          [&_.quantity_input]:focus:border-primary
          [&_.quantity_input]:focus:ring-1
          [&_.quantity_input]:focus:ring-primary/30
          [&_.quantity_input]:outline-none
          
          
          [&_td.actions]:py-10
          [&_td.actions]:border-none
          
          
          [&_.coupon]:flex 
          [&_.coupon]:flex-wrap 
          [&_.coupon]:gap-4 
          [&_.coupon]:items-center 
          [&_.coupon]:float-left
          
          
          [&_.input-text#coupon_code]:bg-transparent 
          [&_.input-text#coupon_code]:border-b 
          [&_.input-text#coupon_code]:border-border 
          [&_.input-text#coupon_code]:text-foreground 
          [&_.input-text#coupon_code]:py-2 
          [&_.input-text#coupon_code]:px-4 
          [&_.input-text#coupon_code]:w-48
          [&_.input-text#coupon_code]:placeholder:text-muted-foreground/40
          [&_.input-text#coupon_code]:focus:border-primary 
          [&_.input-text#coupon_code]:outline-none 
          [&_.input-text#coupon_code]:transition-colors
          
          
          [&_button[name='apply_coupon']]:bg-secondary 
          [&_button[name='apply_coupon']]:text-secondary-foreground 
          [&_button[name='apply_coupon']]:px-8 
          [&_button[name='apply_coupon']]:py-3 
          [&_button[name='apply_coupon']]:rounded-full 
          [&_button[name='apply_coupon']]:text-xs 
          [&_button[name='apply_coupon']]:font-semibold
          [&_button[name='apply_coupon']]:uppercase 
          [&_button[name='apply_coupon']]:tracking-widest 
          [&_button[name='apply_coupon']]:hover:bg-secondary/70 
          [&_button[name='apply_coupon']]:transition-all
          [&_button[name='apply_coupon']]:cursor-pointer
          
          
          [&_button[name='update_cart']]:float-right
          [&_button[name='update_cart']]:bg-transparent 
          [&_button[name='update_cart']]:text-muted-foreground 
          [&_button[name='update_cart']]:border 
          [&_button[name='update_cart']]:border-border 
          [&_button[name='update_cart']]:px-8 
          [&_button[name='update_cart']]:py-3 
          [&_button[name='update_cart']]:rounded-full 
          [&_button[name='update_cart']]:text-xs 
          [&_button[name='update_cart']]:font-semibold
          [&_button[name='update_cart']]:uppercase 
          [&_button[name='update_cart']]:tracking-widest 
          [&_button[name='update_cart']]:hover:border-primary 
          [&_button[name='update_cart']]:hover:text-primary 
          [&_button[name='update_cart']]:transition-all
          [&_button[name='update_cart']]:cursor-pointer
          [&_button[name='update_cart']]:disabled:opacity-50
          
          
          [&_.cart-collaterals]:mt-16 
          [&_.cart-collaterals]:flex
          [&_.cart-collaterals]:justify-end
          
          [&_.cart_totals]:w-full
          [&_.cart_totals]:md:w-1/2
          [&_.cart_totals]:bg-card/40 
          [&_.cart_totals]:p-10 
          [&_.cart_totals]:rounded-2xl 
          [&_.cart_totals]:backdrop-blur-md
          [&_.cart_totals]:border
          [&_.cart_totals]:border-border/10
          [&_.cart_totals]:shadow-xl
          [&_.cart_totals]:shadow-primary/5
          
          
          [&_.cart_totals_h2]:font-serif 
          [&_.cart_totals_h2]:text-3xl 
          [&_.cart_totals_h2]:mb-8 
          [&_.cart_totals_h2]:text-foreground
          [&_.cart_totals_h2]:font-medium
          
          
          [&_.cart_totals_table]:w-full
          [&_.cart_totals_table_th]:text-left
          [&_.cart_totals_table_th]:py-4
          [&_.cart_totals_table_th]:font-medium
          [&_.cart_totals_table_th]:text-muted-foreground
          [&_.cart_totals_table_td]:text-right
          [&_.cart_totals_table_td]:py-4
          [&_.cart_totals_table_td]:font-semibold
          
          
          [&_.order-total_th]:text-foreground
          [&_.order-total_th]:font-serif
          [&_.order-total_th]:text-2xl
          [&_.order-total_td]:text-primary
          [&_.order-total_td]:text-2xl
          [&_.order-total_td]:font-serif
          
          
          [&_.wc-proceed-to-checkout]:mt-8
          [&_.checkout-button]:block 
          [&_.checkout-button]:w-full 
          [&_.checkout-button]:bg-destructive 
          [&_.checkout-button]:text-destructive-foreground 
          [&_.checkout-button]:text-center 
          [&_.checkout-button]:py-4 
          [&_.checkout-button]:rounded-full 
          [&_.checkout-button]:font-semibold 
          [&_.checkout-button]:uppercase 
          [&_.checkout-button]:tracking-widest 
          [&_.checkout-button]:text-sm
          [&_.checkout-button]:hover:bg-destructive/90 
          [&_.checkout-button]:transition-all 
          [&_.checkout-button]:shadow-lg 
          [&_.checkout-button]:shadow-destructive/10
          [&_.checkout-button]:hover:shadow-destructive/25
          [&_.checkout-button]:hover:-translate-y-1
        ">
          [woocommerce_cart]
        </div>
      </div>
    </section>;
}